import { Assumptions } from './static/Assumptions';
import { Policy } from './customer/Policy';
import { Utils } from './Utils';
import { Person } from './customer/Person';
import { amorphicStatic } from '@haventech/amorphic';
import { UICategory, UILoggerSingleton, UIPiiLevelEnum } from './logger/UILoggerSingleton';

export class ApplicationStateLogic {
  static freeLookPeriod(policy: Policy): number {
    let freeLookPeriod = Assumptions.freeLookPeriodDays;
    const ownerState = policy.getApplicationState();
    const owner = policy.getApplicationOwner();
    const ownerAgeOrInsuredAge = owner instanceof Person ? owner.getAge() : null;

    //Adding new rules for coverpath policies
    if (Utils.isCoverpathPlatform(policy.getChannelCode())) {
      if (policy.shouldSkipReplacement()) {
        freeLookPeriod = ownerState === 'CA' ? (ownerAgeOrInsuredAge < 60 ? 11 : 41) : 11;
      } else {
        freeLookPeriod = ownerState === 'NY' ? 61 : ownerState === 'PA' ? 46 : 31;
      }
    } else {
      // keeping the logic same for haven policies
      if (ownerState === 'ND') {
        freeLookPeriod = 20;
      } else if (ownerState === 'FL') {
        freeLookPeriod = 14;
      } else if (ownerState === 'CA') {
        //standard free look period in CA is 30 days for owners >= 60; 10 days otherwise.
        //we add 10 days due to CA's requirement of mailing the paper documents.
        freeLookPeriod = ownerAgeOrInsuredAge >= 60 ? 40 : 20;
      }
    }

    UILoggerSingleton.getInstance().info(
      {
        module: 'ApplicationStateLogic',
        function: 'freeLookPeriod',
        category: UICategory.request,
        context: { piiLevel: UIPiiLevelEnum.s2 },
        data: {
          freeLookPeriod: freeLookPeriod,
          policyNumber: policy.policyNumber,
        },
      },
      'Free Look Days Lookup'
    );

    return freeLookPeriod;
  }

  static mustMailPaperPacket(ownerState: string): boolean {
    return ownerState === 'CA';
  }
}
